import Highlight from "@tiptap/extension-highlight";
import Typography from "@tiptap/extension-typography";
import { EditorContent, useEditor } from "@tiptap/react";
import StarterKit from "@tiptap/starter-kit";

type Props = {
  body: string;
};

export default function Show({ body }: Props) {
  const editor = useEditor({
    extensions: [StarterKit, Highlight, Typography],
    content: JSON.parse(body),
    editable: false,
  });

  return (
    <>
      <EditorContent className="prose" editor={editor} />
    </>
  );
}
